
import { defineComponent, PropType, ref, watch } from "vue";
import { generateThumbnailZip, downloadThumbnails } from "@/service/image.service";
import { ElMessage } from "element-plus";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import { Station } from "@/types";

export default defineComponent({
  name: "DownloadThumbnailsButton",
  props: {
    startDate: { type: [Date, String] as PropType<Date | string | null>, required: false },
    endDate: { type: [Date, String] as PropType<Date | string | null>, required: false },
    id: { type: String, required: true },
    labelling: { type: String, required: true },
  },
  setup(props) {
    const samplingPoint = ref<SamplingPoint | null>(null);
    const camera = ref<string | null>(null);

    watch(
      () => props.id,
      async (newId) => {
        if (newId) {
          try {
            const sp = await getSamplingPointById(Number(newId));
            samplingPoint.value = sp;
            const cameras = await getCamerasConfigurationByStationId(
              (sp.station as Station).id || 0
            );

            const modeleCamera = cameras.find((cam) => cam.modele === true);

            camera.value = modeleCamera?.camera?.code || null;
          } catch (err) {
            console.error(err);
            ElMessage.error("No se pudo obtener el punto");
          }
        }
      },
      { immediate: true }
    );

    const downloadImages = async () => {
      if (!props.startDate || !props.endDate || !samplingPoint.value) return;

      const start = new Date(props.startDate);
      const end = new Date(props.endDate);
      const diffDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);

      if (diffDays > 31) {
        ElMessage.warning(
          "No se puede llevar a cabo la descarga. Selecciona un período inferior a 1 mes."
        );
        return;
      }

      if (diffDays < 0) {
        ElMessage.error("La fecha de inicio debe ser anterior a la fecha de fin");
        return;
      }

      ElMessage.info("Comenzando la descarga...");

      try {
        const zipName = await generateThumbnailZip(
          samplingPoint.value.code || "",
          samplingPoint.value.name || "",
          start,
          end,
          camera.value || "",
          props.labelling
        );

        // await new Promise((r) => setTimeout(r, 5000));

        const response = await downloadThumbnails(zipName);
        const blob = new Blob([response], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = zipName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        ElMessage.success("Descarga completada");
      } catch (error) {
        console.error(error);
        ElMessage.error("No se ha podido realizar la descarga.");
      }
    };

    return { downloadImages, samplingPoint };
  },
});
